import React, {useMemo} from 'react';
import Loader from '../../../components/Loader/Loader';

export type FaxPreviewProps = {
    url: string,
    fileName: string
}

const FaxPreview: React.VFC<FaxPreviewProps> = ({
    url,
    fileName
}) => {

    const isPdf = useMemo(() => {
        const ext = fileName.split('.').pop()?.toLowerCase();
        return ext == 'pdf';
    }, [fileName]);

    const isLoading = useMemo(() => {
        return !((url?.length ?? 0) > 0);
    }, [url, fileName]);

    return isLoading ? (
            <Loader
                dataQa="loading-fax-content-loader"
                absolutePosition
            />
        ) : (
            <div style={{
                width: "100%",
                height: "100%",
                background: "#111",
            }}>
                {isPdf ? (
                    <iframe
                        src={url + '#toolbar=0&navpanes=0'}
                        title={fileName}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            minHeight: 386
                        }}
                        allow="fullscreen"
                    />
                ) : (
                    <img src={url}
                        style={{ 
                            width: '100%', 
                            height: '100%', 
                            objectFit: 'contain'
                        }} 
                    />
                )}
            </div>
    );
}

export default FaxPreview;